'use strict';

import StampStatus from '../constants/StampStatus';

export default function getStampSegment(stamp) {
  const { status, id, uuid } = stamp;

  if (id) {
    return status === StampStatus.UNLISTED ? `${uuid}-${id}` : id.toString();
  } else {
    return uuid || 'new';
  }
}


/** WEBPACK FOOTER **
 ** ./utils/getStampSegment.js
 **/